export default __webpack_public_path__ + "static/media/background.bd0e481c.png";